import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link , useNavigate} from "react-router-dom";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { getNotifications } from "../../actions/notifications";
import { markNotificationsViewed } from "../../api/notifications";
import { getUnreadNotifications } from "../../helpers/common";



const Notification = () => {
  const allNotifications = useSelector((state) => state.notifications);
  const notificationsList = allNotifications.data;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("webvi_userInfo"));
  const customerType = user?.customerType ?? user?.data?.customerType;

  // Notification Dropdown
  const [notification, setNotification] = useState(false);
  const toggleDropdownNotifications = () =>
    setNotification((prevState) => !prevState);

  const unreadNotificationsCount = getUnreadNotifications(notificationsList);

  const onNotificationClick = (e, item) => {
    e.preventDefault();

    markNotificationsViewed(item?.id)
      .then(() => {
        dispatch(getNotifications());
      })
      .catch((err) => {
        console.log("err::", err);
      });

    setNotification(false);

    const currentUser = JSON.parse(localStorage.getItem("webvi_userInfo"));
    const currentCustomerType =
      currentUser?.customerType ?? currentUser?.data?.customerType;

    // Extract values from notification item
    const jobId = item?.jobId;
    const type = item?.type; // e.g., 'job_posted', 'job_applied', 'shortlisted', 'rejected'
    const message = item?.message || "";

    // 1. Direct Job Detail Navigation (if jobId exists and notification is job-specific)
    if (jobId) {
      // Helper to extract clean slug title from message if available
      let jobTitleSlug = "job-details";
      if (message.includes(":")) {
        const extractedTitle = message.split(":")[1]?.trim();
        if (extractedTitle) {
          jobTitleSlug = extractedTitle.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        }
      }

      // If it's a new job posting or general job alert, navigate to job details page
      if (type === "job_posted" || type === "job_alert") {
        navigate(`/job/details/${jobId}/${jobTitleSlug}`);
        return;
      }
    }

    // 2. Application Status Updates (Shortlisted, Rejected, Job Applied, etc.)
    if (currentCustomerType === 0) {
      // Candidate -> Go to candidate application management
      navigate("/candidate/job/application/manage");
    } else {
      // Employer -> Go to employer application management
      navigate("/employer/job/application/manage");
    }
  };

  const NoNotificationsAvailable = () => {
    return (
      <div className="notification-wrapper dropdown-scroll">
        <div className="text-center my-5">
          <i className="mdi mdi-bell my-bell-icon"></i>
          <h6 className="">Notifications are not available yet.</h6>
        </div>
      </div>
    );
  };

  return (
    <Dropdown
      isOpen={notification}
      toggle={toggleDropdownNotifications}
      className="list-inline-item me-4"
    >
      <DropdownToggle
        href="#"
        className="header-item noti-icon position-relative"
        id="notification"
        type="button"
        tag="a"
      >
        <i className="mdi mdi-bell fs-22"></i>
        <div className="count position-absolute">
          {unreadNotificationsCount}
        </div>
      </DropdownToggle>
      <DropdownMenu
        className="dropdown-menu-md dropdown-menu-end p-0"
        aria-labelledby="notification"
        end
      >
        <div className="notification-header border-bottom bg-light ">
          <h6 className="mb-1"> Notification </h6>
          <p className="text-muted fs-13 mb-0">
            You have {unreadNotificationsCount} unread Notification
            {`${unreadNotificationsCount > 1 ? "s" : ""}`}
          </p>
        </div>

        {Array.isArray(notificationsList?.data) &&
        notificationsList.data.length > 0 ? (
          <div className="notification-wrapper dropdown-scroll">
            {notificationsList.data.map((item) => (
              <Link
                to="#"
                key={item?.id}
                onClick={(e) => onNotificationClick(e, item)}
                className="text-dark notification-item d-block active"
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-3">
                    <div className="avatar-xs bg-primary text-white rounded-circle text-center position-relative">
                      <i className="mdi mdi-bell"></i>

                      {item?.isRead === 0 ? (
                        <div className="count unread position-absolute"></div>
                      ) : null}
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1 fs-14">
                      {item?.message || "No Message Available"}
                    </h6>
                    <p className="mb-0 fs-12 text-muted">
                      <i className="mdi mdi-clock-outline"></i>{" "}
                      <span>
                        {item?.createdAt
                          ? moment(item.createdAt).fromNow()
                          : ""}
                      </span>
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <NoNotificationsAvailable />
        )}

        <div className="notification-footer border-top text-center">
          <Link
            className="primary-link fs-13"
            to="/notifications"
            onClick={toggleDropdownNotifications}
          >
            <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
            <span>View More...</span>
          </Link>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default Notification;